export default {
  avatar: {
    uploadEerror: 'Image upload failed. Please try uploading again!',
  }
}